import { Button } from 'primereact/button';
import { EditText } from '../../component/ui/edit-text/edit-text';
import { Password } from 'primereact/password';
import { useState } from 'react';
import { logInOperation } from './operations/log-in-operation';
import { useNavigate } from 'react-router-dom';

export const LoginPage = () => {
  const [mail, setMail] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleOperation = async () => {
    await logInOperation(mail, password, navigate, setLoading);
  };
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'lightblue',
      }}
    >
      <div
        style={{
          width: '465px',
          padding: '55px',
          display: 'flex',
          justifyContent: 'right',
          flexDirection: 'column',
          backgroundColor: 'white',
          borderRadius: '5px', // just the radius value
          border: '1px solid #4b5563',
        }}
      >
        <div style={{ fontSize: '16px', color: 'black' }}>התחברות</div>
        <div style={{ fontSize: '14px', color: '#4b5563', marginTop: '4px' }}>
          הזן את פרטי ההתחברות
        </div>
        <div style={{ marginTop: '16px' }} />
        <EditText title={'מייל'} onChange={setMail} />

        <div
          style={{
            flex: '1', // Flex-grow, flex-shrink, and base size of 250px
            minWidth: '250px', // Ensure a minimum width of 250px
            width: '350px',
            marginBottom: '16px', // Optional bottom margin for row spacing
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '8px' }}
          >
            סיסמא
          </div>
          <Password
            onChange={(e) => setPassword(e.target.value)}
            toggleMask
            inputStyle={{ width: '350px', height: '36px' }}
          />
        </div>
        <Button
          loading={loading}
          style={{ marginTop: '16px' }}
          label="התחברות"
          onClick={handleOperation}
        />
      </div>
    </div>
  );
};
